export default __webpack_public_path__ + "static/media/github.b392be3f.png";